import React, {useEffect} from 'react';
import {contentGroups} from '../lib/gtm/index';

export default function Custom500() {
  useEffect(() => {
    contentGroups({
      cg1: 'error page',
    });
  }, []);
  return <h1>500 - Server-side error occurred</h1>;
}
